module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av366-4322949807067fdb159cd03d14ebb578.jpg";